import { WSPage } from "@wingspanhq/fe-component-library";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useIsEngagementsActive } from "../../../../shared/hooks/useIsEngagementsActive";
import {
  PAYEES_ALL_PATH,
  PAYEES_ARCHIVED_PATH,
  PAYEES_COMPLETE_PATH,
  PAYEES_GROUPS_LIST_PATH,
  PAYEES_INCOMPLETE_PATH,
  PAYEES_NOT_SIGNED_UP_PATH
} from "../../utils";
import { RouteGroups } from "../RouteGroups";
import { RoutePayees } from "../RoutePayees";
import { AlertExpiringRequirements } from "../RoutePayees/AlertExpiringRequirements";
import { DashboardHeader } from "./DashboardHeader";
import { DashboardTabs } from "./DashboardTabs";

export const RoutePayeesDashboard: React.FC = () => {
  const isNewEngagements = useIsEngagementsActive();

  return (
    <WSPage>
      <DashboardHeader />

      <AlertExpiringRequirements />

      <DashboardTabs />

      <Switch>
        {isNewEngagements ? null : (
          <Route path={PAYEES_GROUPS_LIST_PATH} component={RouteGroups} />
        )}

        <Route
          path={[
            PAYEES_ALL_PATH,
            PAYEES_COMPLETE_PATH,
            PAYEES_INCOMPLETE_PATH,
            PAYEES_ARCHIVED_PATH,
            PAYEES_NOT_SIGNED_UP_PATH
          ]}
          component={RoutePayees}
        />

        <Redirect to={PAYEES_ALL_PATH} />
      </Switch>
    </WSPage>
  );
};
